import { DEFAULT_HEADERS } from '../config/api';

export type HeaderType = 'public' | 'authenticated' | 'admin';

class HeaderService {
  private authToken: string | null = null;
  private apiKey: string = import.meta.env.VITE_API_KEY;

  setAuthToken(token: string) {
    this.authToken = token;
  }

  clearAuthToken() {
    this.authToken = null;
  }

  getAuthToken(): string | null {
    return this.authToken;
  }

  getHeaders(type: HeaderType = 'public'): Record<string, string> {
    const headers: Record<string, string> = {
      ...DEFAULT_HEADERS,
      'api-key': this.apiKey, // Cambiado de 'X-API-Key' a 'api-key'
      'platform': 'web', // Agregado platform como en el original
    };

    switch (type) {
      case 'authenticated':
      case 'admin':
        if (this.authToken) {
          headers['Authorization'] = `Bearer ${this.authToken}`;
        }
        break;
      case 'public':
      default:
        // Solo headers básicos para requests públicos
        break;
    }

    return headers;
  }

  isAuthenticated(): boolean {
    const authenticated = !!this.authToken;
    return authenticated;
  }
}

export const headerService = new HeaderService(); 